import React from 'react';
import Panel from '@views/Onboarding/panels/Panel';
import CopySection, { FinishStepButton } from '@views/Onboarding/panels/CopySection';
import BirthdayGraphic from './BirthdayGraphic';
import { Requester } from '.';

export default function Intro({
  requester,
  finishStep,
}: {
  requester: Requester;
  finishStep: () => void;
}) {
  const name = (fallback: string = 'Your friend') => requester.first_name || fallback;
  return (
    <Panel>
      <CopySection>
        <h2>{name()} would like to keep track of your birthday!</h2>
        <p>
          {name()} uses Clay to keep track of the important details of their relationships,
          including birthdays.
        </p>
        <p>Enter your birthday to help {name('them')} remember your special day each year.</p>
      </CopySection>
      <BirthdayGraphic />
      <FinishStepButton onClick={finishStep}>Continue</FinishStepButton>
    </Panel>
  );
}
